import routes from './routes'
import * as repositories from './repositories'

export default {
  routes,
  repositories,
}
